;(async () => {
  const { default: Swiper, Autoplay, EffectFade } = await import('swiper')

  Swiper.use([Autoplay, EffectFade])

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()

      this.storageCountryId = 'CODE:session_country_code'
      this.storageVisibleId = 'CODE:session_bar_visible'

      this.closeButton = this.querySelector('.announcement-bar__close')
      this.swiperElement = this.querySelector('[data-swiper-announcement-bar]')

      // Default options
      this.defaultOptions = {
        locationApiUrl: 'https://extreme-ip-lookup.com/json',
        locationFieldName: 'countryCode',
      }
      this.dataOptions = {}

      // Get options from element data and combine with default options
      if (this?.dataset.options) {
        this.dataOptions = JSON.parse(this.dataset.options)
      }
      this.options = {
        ...this.defaultOptions,
        ...this.dataOptions,
      }

      // Set the swiper options
      this.swiperOptions = {
        fadeEffect: {
          crossFade: true,
        },
        effect: 'fade',
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        slidesPerView: 1,
        direction: 'horizontal',
      }

      // Get all the slides
      this.swiperSlides = this.querySelectorAll('[data-country-code]')

      // Add event handlers
      this.closeButton.addEventListener('click', this.handleClose.bind(this, true))

      this.init()
    }
    init() {
      // Guard if announcement bar needs to be hidden
      if (sessionStorage.getItem(this.storageVisibleId) !== null && sessionStorage.getItem(this.storageVisibleId) === 'false') {
        this.handleClose(false)
        return
      }

      // Init default swiper
      this.initSwiper()

      // Guard if we already have the country code in the session storage
      if (sessionStorage.getItem(this.storageCountryId) !== null) {
        this.renderLocationSlides(sessionStorage.getItem(this.storageCountryId))
      } else {
        this.getCurrentLocationFromUrl()
      }

      if (Shopify.designMode && this.swiperInstance) {
        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update()
        })

        window.addEventListener('shopify:block:select', (event) => {
          this.swiperInstance.update()
          this.handleThemeEditorEvents(event)
        })
      }
    }

    initSwiper() {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
    }

    /**
     * Render location specific slides
     */
    renderLocationSlides(countryCode) {
      let locationSlidesCounter = 0
      this.swiperSlides.forEach((swiperSlide) => {
        // Check if location slides for countryCode exist
        if (swiperSlide.dataset.countryCode == countryCode) {
          locationSlidesCounter = locationSlidesCounter + 1
        }
      })

      // Guard: if there are no country specific messages
      if (!locationSlidesCounter > 0) {
        return
      }

      this.swiperSlides.forEach((swiperSlide) => {
        // Hide all slides by default
        swiperSlide.classList.add('announcement-bar__slide--hidden')

        // Check if location slides for countryCode exist
        if (swiperSlide.dataset.countryCode == countryCode) {
          swiperSlide.classList.remove('announcement-bar__slide--hidden')
        }
      })

      // Destroy and reinitialize the swiper
      this.swiperInstance.destroy()
      this.initSwiper()
    }

    /**
     * Get the current location from the url and save in session storage
     */
    getCurrentLocationFromUrl() {
      // Fetch the current country code from the API
      fetch(this.options.locationApiUrl)
        .then((response) => response.json())
        .then((data) => {
          // On success send country code to render
          if (data && data[this.options.locationFieldName]) {
            this.renderLocationSlides(data[this.options.locationFieldName])
          }

          // Save the new country code in the session storage
          sessionStorage.setItem(this.storageCountryId, data[this.options.locationFieldName])
        })
        .catch((e) => {
          console.error(e, 'Announcement bar error - Failed to fetch from location API url.')
        })
    }

    /**
     * Set the bottom property of the header
     */
    setHeaderWrapperBottomProperty() {
      const siteHeader = document.querySelector('[data-header]')
      const boundingClientRect = siteHeader.getBoundingClientRect()
      const headerWrapperBottom = boundingClientRect.bottom.toString()
      document.documentElement.style.setProperty('--header-bottom-position', `${headerWrapperBottom}px`)
    }

    /**
     * Handles the close of the announcement bar
     */
    handleClose(setStorage = true) {
      const announcementBarWrapper = this.closest('.announcement-bar__wrapper')
      announcementBarWrapper.style.height = 0

      if (setStorage) {
        sessionStorage.setItem(this.storageVisibleId, false)
      }

      this.setHeaderWrapperBottomProperty()
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleThemeEditorEvents(event) {
      // Slide to slide based on the data attribute from the target and add 1 to get the slide index
      this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1)
    }
  }

  window.AnnouncementBar = AnnouncementBar

  customElements.define('announcement-bar', AnnouncementBar)
})()
